import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { InfoIcon, MaximizeIcon, MinimizeIcon } from 'lucide-react';
interface ConfidenceNotificationProps {
  uplift: number;
  confidence: number;
}
export const ConfidenceNotification: React.FC<ConfidenceNotificationProps> = ({
  uplift,
  confidence
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: 1.5,
    duration: 0.5
  }} className="fixed bottom-6 right-6 z-50" data-id="element-346">
      <AnimatePresence mode="wait" data-id="element-347">
        {!isExpanded ? <motion.div key="collapsed" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.95
      }} className="bg-white rounded-xl shadow-lg border border-gray-200 p-4 flex items-center space-x-3 cursor-pointer hover:shadow-xl transition-shadow" onClick={() => setIsExpanded(true)} data-id="element-348">
            <InfoIcon className="h-5 w-5 text-[#1E90FF] flex-shrink-0" data-id="element-349" />
            <span className="text-sm font-semibold text-gray-900" data-id="element-350">
              +{uplift}% Brand Lift
            </span>
            <MaximizeIcon className="h-4 w-4 text-gray-400 ml-2" data-id="element-351" />
          </motion.div> : <motion.div key="expanded" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.95
      }} className="bg-white rounded-xl shadow-xl border border-gray-200 p-6 w-80" data-id="element-352">
            <div className="flex items-start justify-between mb-3" data-id="element-353">
              <div className="flex items-center space-x-3" data-id="element-354">
                <InfoIcon className="h-6 w-6 text-[#1E90FF] flex-shrink-0" data-id="element-355" />
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-356">
                  {confidence}% Confidence Level
                </h3>
              </div>
              <button onClick={() => setIsExpanded(false)} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-357">
                <MinimizeIcon className="h-4 w-4" data-id="element-358" />
              </button>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed" data-id="element-359">
              Results at this level indicate very strong statistical confidence
              in the findings. The campaign achieved a{' '}
              <span className="font-semibold text-[#1E90FF]" data-id="element-360">
                +{uplift}% brand lift
              </span>{' '}
              with high certainty.
            </p>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
};